import { cyrb64Hash } from '@helios/frontend-core';
import { Property } from './types';

export const getBuildingAttributeHash = ({ building, address: { coordinates } }: Property, propertyId: string) => {
  const buildingEntries = Object.entries(building).map(([k, v]) => v);
  const str = [propertyId, coordinates, ...buildingEntries];

  return cyrb64Hash(JSON.stringify(str));
};
